import React from 'react';

const ViewResultsButtonSection = props => (
  <section className="view-results-button-section">
    {props.children}
  </section>
);

export default ViewResultsButtonSection;
